/**
 * Chuỗi của nhóm màn Kho dữ liệu (`/tro-ly-ai/ban-sao`, `/tro-ly-ai/ban-sao/:nguon`) — port `troLyAi.banSao` (trừ
 * `banSao.khuon`) và `troLyAi.khoView` của native. Tạm tách tệp khi dựng song song, sẽ gộp vào `vi.ts`.
 *
 * Chuỗi có `<b>…</b>` được vẽ bằng `ChuDam` (tách đoạn đậm thành nút React, không chèn HTML).
 */
export const viKho = {
  troLyAiKhoView: {
    tieuDe: 'Kho dữ liệu',
    phuDe: 'Chọn một nguồn để kết nối & đồng bộ, khai báo nghiệp vụ và ghi chú thuật ngữ.',
    moiCachLay: 'Mọi cách lấy dữ liệu',
    banSao: 'Bản sao',
    trucTiep: 'Truy vấn trực tiếp',
    theoKhuon: 'Trả lời theo truy vấn mẫu',
    khongDocTrangThai: 'Không đọc được trạng thái',
    dangDongBo: 'Đang đồng bộ…',
    chuaKhaiBang: 'Chưa khai báo bảng nào',
    coBangDung: '{{n}} bảng · {{dung}} bảng dừng đồng bộ',
    demBang: '{{n}} bảng · {{dong}} dòng',
    demBangTrucTiep: '{{n}} bảng đã khai báo',
  },
  troLyAiKho: {
    thanhHanhDong: 'Thao tác với nguồn',
    tabViec: 'Việc trên nguồn này',
    trucTiep: 'Truy vấn trực tiếp',
    tatCaNguon: 'Tất cả nguồn',
    khongCoNguon: 'Không tìm thấy nguồn',
    khongCoNguonMoTa: 'Nguồn «{{ma}}» không tồn tại, là nguồn API (xem ở Truy vấn mẫu) hoặc tài khoản này không được thấy nó.',
    tieuDe: 'Kho dữ liệu',
    phuDe: 'Với nguồn không hỗ trợ truy vấn có điều kiện, nền tảng đồng bộ dữ liệu về bản sao theo lịch và truy vấn trên bản sao. Mỗi bảng có thời điểm cập nhật dữ liệu, và mọi câu trả lời dựa trên bảng đó đều ghi kèm thời điểm này.',
    dongBoXongCoDung: 'Đồng bộ xong, {{n}} bảng dừng giữa chừng: {{ds}}. Xem lý do và cách xử lý ở cột “Lần chạy gần nhất”.',
    dongBoBiNgat: 'Chu kỳ đồng bộ bị ngắt giữa chừng ở bảng {{bang}} (máy chủ khởi động lại?). Bấm Đồng bộ để chạy lại.',
    dongBoXong: 'Đồng bộ xong {{n}} bảng',
    dongBoBatDau: 'Đã bắt đầu đồng bộ {{n}} bảng, chạy nền — theo dõi tiến độ ở Trạng thái kho dữ liệu',
    khongDongBoDuoc: 'Không đồng bộ được — {{loi}}',
    timThayDeXuat: 'Tìm thấy {{n}} đề xuất',
    khongThayDeXuat: 'Không thấy đề xuất nào',
    doTimHetGio: 'Hết thời gian dò: có {{n}} đề xuất, còn {{boQua}} phép dò chưa chạy. Tắt bớt bảng không dùng rồi dò lại để rà đủ.',
    khongDoDuoc: 'Không dò được — {{loi}}',
    rongTieuDe: 'Chưa kết nối nguồn dữ liệu nào',
    rongMoTa: 'Sang màn Kết nối để thêm một nguồn — dịch vụ GraphQL hoặc chuỗi kết nối tới cơ sở dữ liệu của khách hàng.',
    sangKetNoi: 'Sang màn Kết nối',
    khaiBangTuNguon: 'Chọn bảng từ CSDL',
    doMaQuanHe: 'Dò mã & quan hệ',
    goiYTaiHuongDan: 'Tải tệp Word hướng dẫn cách khai báo bảng và cột — mở được ngay cả khi chưa kết nối nguồn nào.',
    goiYKhaiBangTuNguon: 'Đọc lược đồ của cơ sở dữ liệu nguồn rồi mở hộp chọn bảng cần khai báo. Chỉ cần kết nối, chưa cần đồng bộ.',
    goiYDoMaQuanHe: 'Dùng khi cơ sở dữ liệu nguồn không khai báo khoá ngoại: hệ thống so sánh giá trị thực trong kho để suy đoán bảng nào nối được với bảng nào, cột nào chỉ có vài giá trị cố định, và bảng nào đã ngừng dùng. Cần kho đã có dữ liệu.',
    goiYDongBoNgay: 'Đồng bộ dữ liệu mới từ nguồn về bản sao và đo lại thống kê của từng bảng.',
    dongBoNgay: 'Đồng bộ ngay',
    taiHuongDan: 'Hướng dẫn khai báo',
    tabNguon: 'Kết nối & đồng bộ',
    tabKhai: 'Khai báo nghiệp vụ',
    tabTriThuc: 'Tri thức gắn kèm',
    nhanNguon: 'Nguồn:',
    luocDoRong: 'Không đọc được bảng nào. Kiểm tra tài khoản có quyền USAGE trên lược đồ chưa — thiếu quyền cũng cho kết quả rỗng y hệt cơ sở dữ liệu rỗng.',
    khongDocDuocLuocDo: 'Không đọc được lược đồ: {{loi}}',
    doThongKe: 'Đo thống kê cột',
    goiYDoThongKe: 'Nguồn truy vấn trực tiếp không có chu kỳ đồng bộ. Đo lại thống kê (số giá trị, khoảng, tỉ lệ trống) trên CSDL khách khi dữ liệu đổi nhiều — bảng lớn đo trên mẫu.',
    daDoThongKe: 'Đã đo {{n}} bảng.',
    dangDoThongKe: 'Đang đo thống kê từng cột trên CSDL — nguồn lớn có thể mất vài phút.',
    khongDoDuocThongKe: 'Không đo được thống kê — {{loi}}',
    tabKhuon: 'Truy vấn mẫu',
    dangTheoKhuon: 'Nguồn này đang trả lời theo truy vấn mẫu nên phần khai báo bằng câu hỏi không có hiệu lực. Ở đây chỉ còn kết nối, đồng bộ và thuật ngữ.',
    moKhuonNghiepVu: 'Mở Truy vấn mẫu',
  },
  troLyAiKhoTriThuc: {
    moTa: 'Trợ lý tra những bộ này khi câu hỏi cần <b>quy định, định nghĩa, hướng dẫn</b> — thứ không nằm trong bảng số liệu. Không gắn bộ nào thì nó chỉ trả lời bằng dữ liệu.',
    daGan: 'Đã gắn bộ tri thức',
    khongGanDuoc: 'Không gắn được — {{loi}}',
    treoTieuDe: '{{n}} bộ đã gắn nhưng không còn đọc được',
    treoGhi: 'Bộ đã bị xoá ở Tri thức AI, hoặc tài khoản này không có quyền đọc. Mã không còn hợp lệ:',
    treoLuuDeGo: '. Lưu lại để gỡ các mã này.',
    rongTieuDe: 'Chưa có bộ tri thức nào',
    rongMoTa: 'Tạo bộ ở màn Tri thức AI trước, rồi quay lại đây để gắn.',
    soBoChon: '{{n}} bộ được chọn',
    chuaLuu: ' · chưa lưu',
    tieuDe: 'Bộ tri thức gắn cho nguồn này',
  },
  troLyAiKhoSync: {
    colCapNhatDen: 'Dữ liệu cập nhật đến',
    dongBoLaiBang: 'Đồng bộ lại bảng này',
    thaoTacBang: 'Thao tác với bảng {{bang}}',
    colBang: 'Bảng',
    colSoDongDo: 'Số dòng (lần đo gần nhất)',
    colCotDaDo: 'Cột đã đo',
    uocLuong: 'ước lượng',
    chuaDo: 'Chưa đo',
    oDoLuc: 'Đo thống kê lúc',
    oDoLucSub: 'bấm “Đo thống kê cột” để cập nhật',
    colSoDong: 'Số dòng',
    colBietXoa: 'Phát hiện dòng đã xoá',
    colLanChay: 'Lần chạy gần nhất',
    tangDan: 'đồng bộ tăng dần',
    chepDayDu: 'đồng bộ toàn bộ mỗi chu kỳ',
    chuaDongBo: 'chưa đồng bộ',
    giaDinhChiThem: 'giả định chỉ thêm mới',
    rongCoNguon: 'Chưa có bảng nào. Bấm “Chọn bảng từ CSDL” để đọc cấu trúc và chọn bảng cần lấy.',
    rongKhongNguon: 'Chưa khai báo bảng nào. Dùng “Chọn bảng từ CSDL”, hoặc tạo bản sao lần đầu bằng scripts/.',
    chuKyVuaChay: 'Chu kỳ vừa chạy',
    thongKeChuKy: '{{cheDo}} · lấy về {{doc}} dòng · ghi vào kho {{ghi}} dòng · xoá {{xoa}} dòng · {{giay}} giây',
    cheDoDayDu: 'Đồng bộ toàn bộ',
    cheDoPhanMoi: 'Đồng bộ tăng dần',
    boDoThayGi: 'Phát hiện {{n}} đề xuất',
    chacCao: 'khá chắc',
    chacVua: 'cần xem lại',
    chacThap: 'chỉ là phỏng đoán',
    boDoGhi: 'Hệ thống phân tích trên chính dữ liệu đã đồng bộ về rồi đưa ra đề xuất; bạn là người xác nhận từng mục. Không có nút duyệt tất cả là có chủ ý: một quan hệ suy đoán sai sẽ đi thẳng vào câu lệnh và cho ra một con số có thật nhưng trả lời sai câu hỏi.',
    boDoRong: 'Không phát hiện gì. Nếu kho chưa có dữ liệu thì đây là kết quả đúng — hệ thống cần dữ liệu thực mới suy đoán được quan hệ và danh sách giá trị. Hãy chạy Đồng bộ ngay rồi dò lại.',
    daGhi: 'đã ghi',
    ghiVaoBanKhai: 'Ghi vào bản khai báo',
    daGhiToast: 'Đã ghi vào bản khai báo — {{muc}}',
    khongGhiDuoc: 'Không ghi được — {{loi}}',
    oBang: 'Bảng đã khai báo',
    oDong: 'Dòng đã đồng bộ',
    oTangDan: 'Đồng bộ tăng dần',
    oMoiNhat: 'Dữ liệu mới nhất',
    oTangDanSub: '{{n}} bảng còn đồng bộ toàn bộ',
    oBangSub: 'trên nguồn này',
    oDongSub: 'cộng mọi bảng',
    chuaCo: '—',
    bangTieuDe: 'Trạng thái kho dữ liệu',
    tienDoDangChay: 'Đang đồng bộ bảng {{bang}} ({{thuTu}}/{{soBang}}) · đã đọc {{daDoc}} dòng · bắt đầu {{batDau}}',
    tienDoChuanBi: 'Đang chuẩn bị đồng bộ {{soBang}} bảng (đọc lược đồ nguồn) · bắt đầu {{batDau}}',
    tienDoDoHoSo: 'Đã đồng bộ xong {{soBang}} bảng · đang đo thống kê dữ liệu',
    tienDoBiNgat: 'Chu kỳ bắt đầu {{batDau}} bị ngắt ở bảng {{bang}} ({{thuTu}}/{{soBang}}) — không còn tín hiệu hoạt động từ {{capNhat}}. Bấm Đồng bộ để chạy lại.',
    trangThaiDangChay: 'đang chạy',
    trangThaiOk: 'thành công',
    trangThaiDung: 'dừng giữa chừng',
    trangThaiBoQua: 'bỏ qua',
    colDongBo: 'Đồng bộ',
    dongBoBangNhan: 'Đồng bộ lại riêng bảng {{bang}}',
    goiYDongBoBang: 'Chạy lại riêng bảng {{bang}} — không ảnh hưởng tới các bảng khác.',
    goiYDongBoBangDangBan: 'Nguồn đang có một chu kỳ đồng bộ chưa xong. Chờ chu kỳ này kết thúc rồi mới đồng bộ riêng từng bảng được.',
    dongBoBangBatDau: 'Đang đồng bộ lại bảng {{bang}} — theo dõi ở cột “Lần chạy gần nhất”.',
    khongDongBoDuocBang: 'Không đồng bộ được bảng — {{loi}}',
    colXoa: 'Xoá',
    xoaBangNhan: 'Xoá bảng {{bang}} khỏi bản khai báo',
    xacNhanXoaBang: 'Xoá bảng “{{bang}}”?',
    xacNhanXoaBangGhi: 'Bảng này sẽ bị gỡ khỏi bản khai báo và xoá khỏi kho bản sao, kèm toàn bộ dữ liệu đã đồng bộ về. Không thể hoàn tác — muốn dùng lại thì phải chọn lại bảng từ CSDL và đồng bộ từ đầu.',
    xoaBang: 'Xoá bảng',
    huy: 'Huỷ',
    daXoaBang: 'Đã xoá bảng {{bang}}.',
    xoaBangLamLech: '{{n}} định nghĩa nghiệp vụ không còn bảng tham chiếu sau khi xoá: {{ds}}',
    xoaBangGoQuyen: 'Gỡ luôn bảng này khỏi quyền đọc của {{n}} vai trò. Xem lại ở Phân quyền dữ liệu.',
    khongXoaDuocBang: 'Không xoá được bảng — {{loi}}',
    oCheDo: 'Cách đọc',
    oCheDoTrucTiep: 'Trực tiếp',
    oCheDoTrucTiepSub: 'không có bản sao — câu hỏi đọc trực tiếp nguồn',
  },
  troLyAiKhoSyncNhom: {
    quanHe: {
      ten: 'Quan hệ giữa các bảng · {{n}}',
      mo: 'Dùng khi cơ sở dữ liệu nguồn không khai báo khoá ngoại. Hệ thống so sánh giá trị thực ở hai cột để suy đoán bảng nào nối được với bảng nào. Ghi vào bản khai báo thì trợ lý mới được phép nối (JOIN) hai bảng đó khi trả lời.',
    },
    giaTri: {
      ten: 'Cột chỉ có vài giá trị · {{n}}',
      mo: 'Những cột mà cả bảng chỉ dùng vài giá trị cố định — trạng thái, loại, khu vực. Ghi vào bản khai báo thì trợ lý lọc đúng chính tả. Nếu là mã viết tắt, sang tab Khai báo nghiệp vụ để điền nghĩa cho từng mã.',
    },
    bangChet: {
      ten: 'Bảng có thể đã ngừng dùng · {{n}}',
      mo: 'Đã lâu không có dòng mới. Ghi vào bản khai báo nghĩa là tắt bảng — bảng thừa làm tăng nguy cơ trợ lý lấy nhầm số. Bảng chỉ cập nhật theo mùa thì bỏ qua.',
    },
    soLech: {
      ten: 'Số dòng lệch · {{n}}',
      mo: 'Số dòng cung cấp cho trợ lý khác số dòng thực tế trong kho. Không có gì để ghi ở đây — hãy chạy Đồng bộ ngay một lượt rồi dò lại.',
    },
  },
  troLyAiKhoKhai: {
    nghiaCuaMa: '{{cau}} — {{ma}}',
    chonTep: 'Chọn tệp trả lời',
    hauQua: {
      sai_am_tham: 'trả lời sai mà không ai biết',
      bi_tu_choi: 'bị từ chối, người dùng thấy',
      kho_doc: 'chỉ khó đọc',
      'sai_am_tham,bi_tu_choi': 'nên xử lý trước',
    },
    khongSinhDuoc: 'Không sinh được câu hỏi — {{loi}}',
    daGhiCoBoQua: 'Đã lưu {{n}} khai báo · {{m}} câu bị bỏ qua: {{ds}}',
    daGhiCoDeLen: '{{n}} thuật ngữ trùng tên đã ghi đè khai báo cũ — bản cũ không còn: {{ds}}',
    daGhi: 'Đã lưu {{n}} khai báo',
    khongGhiDuoc: 'Không ghi được — {{loi}}',
    khongRoBang: '(không rõ bảng)',
    tieuDe: 'Câu hỏi nghiệp vụ',
    moTa: 'Những chỗ bản khai báo còn trống, xếp theo <b>mức độ ảnh hưởng khi thiếu</b>. Mỗi lựa chọn kèm số liệu lấy từ chính dữ liệu của bạn để dễ quyết định.',
    hoiLai: 'Hỏi lại',
    batDau: 'Bắt đầu',
    moiBatDau: 'Bấm <b>Bắt đầu</b> để đọc thống kê dữ liệu đã đo và liệt kê những chỗ bản khai báo còn trống.',
    daDu: 'Bản khai báo đã đầy đủ — không còn chỗ nào cần hỏi.',
    chipHauQua: '{{n}} câu · {{mo}}',
    luu: 'Lưu',
    luuSoLoiKhai: 'Lưu {{n}} khai báo',
    duyetCaBang: 'Duyệt {{n}} gợi ý của bảng này',
    duyetTatCa: 'Duyệt tất cả {{n}} gợi ý (mọi bảng)',
    duyetTatCaMoiBang: 'Duyệt tất cả gợi ý (mọi bảng)',
    daDuyetTatCa: 'Đã duyệt {{n}} gợi ý trên mọi bảng — xem lại rồi bấm Lưu.',
    khongConGoiY: 'Không còn gợi ý nào chưa duyệt.',
    goiYChuaDuyet: 'Gợi ý chưa duyệt không được tính vào khai báo.',
    traLoiPlaceholder: 'Trả lời…',
    nghiaPlaceholder: 'Mã này nghĩa là gì…',
    daDuyet: 'đã duyệt',
    duyet: 'Duyệt',
    goiYNhan: 'gợi ý · chưa duyệt — chưa tính vào khai báo',
    goiYCanCu: 'Căn cứ:',
    tomTatSaiAmTham: 'Còn {{n}} câu có thể gây sai số liệu mà không ai phát hiện',
    tomTatBiTuChoi: '{{n}} câu sẽ bị chặn khi hỏi tới',
    tomTatKhoDoc: '{{n}} câu chỉ ảnh hưởng cách hiển thị',
    phaiGatTungCai: '{{n}} gợi ý không nằm trong nút duyệt hàng loạt: những câu mà nếu trả lời sai thì con số vẫn hiện ra và không ai phát hiện, cùng những gợi ý chỉ suy đoán theo tên cột. Hai loại đó phải xác nhận từng mục.',
    locTieuDe: 'Lọc',
    locMo: 'Mặc định mở ở mức nên xử lý trước. Bấm nhãn lọc khác để xem tất cả — rồi chọn bảng, danh sách bên phải thay đổi theo.',
    cauCanKhai: 'Câu cần khai báo',
    chuaChonBang: 'Chọn một bảng bên trái để xem các câu cần khai báo.',
    dangTaiBang: 'Đang tải câu của bảng này…',
    locKhongCoCau: 'Không có câu nào ở mức ảnh hưởng này. Bỏ chọn nhãn lọc để xem lại tất cả.',
    phamViCoHet: 'Chọn Có cho {{n}} bảng chưa trả lời',
    phamViKhongHet: 'Chọn Không cho {{n}} bảng',
    phamViLoatXong: 'Đã xác nhận phạm vi cho {{n}} bảng. Bảng bạn đã tự trả lời được giữ nguyên.',
    phamViLoatHong: 'Không xác nhận được: {{loi}}',
    moTaDangDoc: 'Đang đọc tệp trả lời…',
    moTaDaChonSan: 'Đã chọn sẵn {{n}} câu có lựa chọn — soát lại rồi bấm Lưu.',
    moTaHong: 'Không đọc được tệp trả lời: {{loi}}',
    tepRong: 'Tệp không có chữ nào đọc được.',
    xuatCauHoi: 'Xuất {{n}} câu',
    xuatHong: 'Không xuất được: {{loi}}',
    moTaTaiLenBo: 'Tải tệp trả lời · {{n}} câu',
    tepSaiDinhDang: 'Chỉ nhận tệp trả lời dạng {{duoi}} — đúng mẫu tải về từ nút Xuất.',
    tuTepTraLoi: 'Từ tệp trả lời',
    tepDaDoc: 'Đã đọc {{n}} câu trả lời từ tệp. Soát rồi bấm Duyệt.',
    tepKhongCoTraLoi: 'Tệp không có câu trả lời nào khớp mã câu còn trống.',
    tepCoLoi: '{{n}} dòng/câu bị bỏ vì sai định dạng hoặc sai giá trị — đã tải về tệp lỗi để sửa.',
  },
  troLyAiKhoKetQuaDo: {
    giay: '{{so}} giây',
    tieuDe: 'Kết quả đo thống kê cột',
    moTa: 'Nền tảng vừa đếm số dòng, số giá trị khác nhau, tỉ lệ trống, giá trị nhỏ nhất/lớn nhất và danh sách giá trị của các cột ít giá trị trên từng bảng đang bật. Trợ lý dùng các số này để hiểu cột chứa gì và gợi ý câu hỏi khai báo. Bảng lớn đo trên mẫu dòng.',
    bang: 'Bảng đã đo',
    cot: 'Cột',
    dong: 'Dòng đã đọc',
    thoiGian: 'Thời gian',
    boQuaTat: 'Bỏ qua {{n}} bảng đang tắt — bật lại ở tab Nghiệp vụ đã khai báo nếu cần đo.',
    bangLoi: '{{n}} bảng không đo được',
    cotBo: '{{n}} cột không đo được (thường là cột văn bản dài như ntext/image mà CSDL không cho đếm giá trị khác nhau) — các cột khác của bảng vẫn có số đo.',
    colBang: 'Bảng',
    colDong: 'Số dòng',
    colCot: 'Cột đã đo',
    colGhiChu: 'Ghi chú',
    trenMau: 'đo trên mẫu',
    cotKhongDo: 'bỏ qua {{n}} cột: {{ds}}',
  },
  troLyAiKhoDaKhai: {
    phamViHoi: 'Trợ lý có được lấy số từ bảng này không',
    phamViCo: 'Có — cho trợ lý dùng',
    phamViKhong: 'Không — bỏ bảng này ra',
    phamViChua: 'Hỏi lại ở màn Phỏng vấn',
    chiBangTat: 'Chỉ hiện {{n}} bảng đang tắt',
    tab: 'Nghiệp vụ đã khai báo',
    moTa: 'Khai báo hiện tại. Sửa được tại chỗ — bấm Lưu thì mới ghi nhận.',
    luu: 'Lưu',
    choLuu: '{{n}} thay đổi chờ lưu',
    daLuu: 'Đã lưu {{n}} bảng.',
    khongLuuDuoc: 'Không lưu được: {{loi}}',
    rong: 'Chưa khai báo gì',
    rongMo: 'Sang tab Khai báo nghiệp vụ trả lời vài câu, sau đó quay lại đây để rà soát và chỉnh sửa.',
    soCotDaKhai: '{{n}} cột đã khai báo',
    chuaKhai: 'chưa khai báo',
    grain: 'Mỗi dòng của bảng này biểu diễn điều gì',
    nhan: 'Nhãn nghiệp vụ',
    donVi: 'Đơn vị',
    trongNghiaLa: 'Ô trống nghĩa là gì',
    soMa: '{{n}} mã đã giải nghĩa',
    tat: 'đã tắt',
    congDonHoi: 'Cộng các giá trị của cột này lại có nghĩa không?',
    congDonCo: 'Có — ra một con số có nghĩa',
    congDonKhong: 'Không — tỷ lệ, đơn giá, ngưỡng',
    congDonChua: 'Chưa khai báo',
    xoaKhai: 'Xoá khai báo',
    huy: 'Huỷ',
    xacNhanXoaKhai: 'Xoá khai báo của bảng «{{bang}}»?',
    xacNhanXoaKhaiGhi: 'Chỉ gỡ khai báo nghiệp vụ của bảng này: phạm vi, kiểu bảng, mô tả ý nghĩa mỗi dòng, nhãn, đơn vị, cộng dồn và nghĩa ô trống của mọi cột. Bảng vẫn nằm trong danh sách đã chọn từ CSDL, vẫn đồng bộ, dữ liệu ở kho giữ nguyên. Bảng sẽ quay lại màn Khai báo nghiệp vụ như chưa được khai báo.',
    daXoaKhai: 'Đã gỡ khai báo của «{{bang}}».',
    daXoaKhaiNhieu: 'Đã gỡ khai báo của {{n}} bảng.',
    xacNhanXoaKhaiNhieu: 'Xoá khai báo của {{n}} bảng đã chọn?',
    xoaDaChon: 'Xoá khai báo ({{n}})',
    chonHet: 'Chọn tất cả',
    khongXoaDuocKhai: 'Không xoá được: {{loi}}',
  },
  troLyAiKhoKhaiBang: {
    thieuBangDong: '{{n}} chứng từ đang chọn bảng tiêu đề mà thiếu bảng chi tiết: {{ds}}. Thiếu bảng chi tiết thì không hỏi được ở mức mặt hàng.',
    tichKemBangDong: 'Chọn kèm {{n}} bảng chi tiết',
    soDong: '{{n}} dòng',
    bangRong: 'rỗng',
    bangCuaKhach: 'bảng của bạn',
    anBangRong: 'Ẩn {{n}} bảng rỗng (không có dòng nào)',
    copyXong: 'Đã sao chép bộ {{m}} cột sang {{n}} bảng. Những bảng đó cũng được chọn để khai báo — hãy rà soát trước khi Lưu.',
    tieuDe: 'Chọn bảng từ CSDL',
    moTa: 'Đây là bản khai báo đề xuất, chưa lưu. Bỏ chọn những bảng không cần đồng bộ; các bảng còn lại sẽ được tạo trong cơ sở dữ liệu bản sao. Lưu ý: bỏ chọn một bảng đã khai báo không gỡ bảng đó ra — muốn gỡ thì xoá bảng ở tab “Kết nối & đồng bộ”.',
    canhBao: 'Bỏ qua khoá ngoại ghép nhiều cột: {{ds}}. Quan hệ ấy phải khai báo thủ công.',
    daChon: 'Đã chọn {{n}}/{{m}} bảng',
    chonHet: 'Chọn hết',
    boHet: 'Bỏ hết',
    soCot: '{{n}} cột',
    tangDan: 'đồng bộ tăng dần',
    chepDay: 'đồng bộ toàn bộ mỗi lần',
    khoaChinh: 'khoá chính: {{ds}}',
    khaiN: 'Lưu {{n}} bảng',
    dangLuu: 'Đang lưu {{n}}/{{m}} bảng…',
    huy: 'Huỷ',
    daKhai: 'Đã lưu {{n}} bảng, tạo mới {{m}} bảng ở kho dữ liệu.',
    khongKhaiDuoc: 'Không lưu được: {{loi}}',
    timPlaceholder: 'Tìm bảng theo mã hoặc tên — ví dụ OINV, hoá đơn',
    timKhongThay: 'Không có bảng nào khớp.',
    dangLoc: 'lọc còn {{n}}',
    chonHetLoc: 'Chọn {{n}} kết quả',
    boHetLoc: 'Bỏ {{n}} kết quả',
    hienThem: 'Hiện thêm ({{n}} bảng nữa)',
    boQuaTong: 'Bỏ qua {{n}} bảng không tạo được bản khai báo:',
    thuGon: 'thu gọn',
    xemTen: 'Xem tên',
    lyDo: {
      qua_nhieu_cot: '{{n}} bảng quá 1000 cột',
      khoa_chinh_qua_dai: '{{n}} bảng có khoá chính quá 12 cột',
      khoa_chinh_nullable: '{{n}} bảng/khung nhìn có cột khoá chính cho phép rỗng',
      khac: '{{n}} bảng vì lý do khác',
    },
    nhieuBang: 'Đang chọn {{n}} bảng. Vẫn lưu được, nhưng mỗi bảng là một bảng tạo trong kho bản sao, được đồng bộ lại mỗi chu kỳ, và thêm một dòng trong lược đồ gửi cho mô hình. Nên ưu tiên những bảng thực sự có số liệu bạn định hỏi.',
    soCotDaBo: 'giữ {{n}}/{{m}} cột',
    moChonCot: 'Chọn cột cho bảng này',
    cotMoi: '+{{n}} cột mới ở nguồn',
    boCotRong: 'Bỏ {{n}} cột rỗng (mọi bảng)',
    boCotRongMo: 'cột đã đo và không có một giá trị nào — mỗi cột tốn ~50 token ở mọi lượt hỏi',
    daBoCotRong: 'Đã bỏ {{n}} cột rỗng. Mở từng bảng để chọn lại nếu cần, rồi bấm Lưu.',
    gomCanhBao: '{{n}} loại cảnh báo — loại phổ biến nhất có ở {{m}} bảng',
    xemChiTiet: 'xem',
    nBang: '{{n}} bảng',
    moCanhBaoBang: 'Xem cảnh báo của bảng này',
    locNhanh: {
      co_dulieu: '{{n}} có dữ liệu',
      da_khai: '{{n}} đã chọn',
      rong_cot: '{{n}} bảng ≥80 cột',
    },
  },
  troLyAiKhoCopyCot: {
    tieuDe: 'Sao chép bộ cột của ‘{{bang}}’ sang bảng khác',
    moTa: 'Bảng đích sẽ giữ đúng {{n}} cột đang giữ ở bảng này, khớp theo tên cột (không phân biệt hoa thường). Cột khoá chính, cột mốc thời gian và cột liên kết của bảng đích luôn được giữ. Cột riêng của từng bảng thì thêm sau.',
    timPlaceholder: 'Tìm bảng…',
    demUngVien: '{{n}}/{{m}} bảng khớp được ít nhất một cột',
    soKhop: '{{n}}/{{m}} cột',
    chonHet: 'Chọn hết',
    boHet: 'Bỏ hết',
    khongCoBang: 'Không có bảng nào khớp ô tìm.',
    huy: 'Huỷ',
    apDung: 'Sao chép sang {{n}} bảng',
  },
  troLyAiKhoChonCot: {
    copySang: 'Sao chép bộ cột này sang bảng khác…',
    tim: 'Tìm cột…',
    giuHet: 'Giữ hết',
    boHet: 'Bỏ hết',
    daGiu: 'Giữ {{n}}/{{m}} cột. Cột bị bỏ sẽ không được tạo trong kho bản sao và không được đưa vào ngữ cảnh gửi cho mô hình.',
    khongThay: 'Không có cột nào khớp.',
    khoa: {
      kc: 'Cột khoá chính — bỏ đi thì bản khai báo không hợp lệ.',
      moc: 'Cột mốc thời gian — bỏ đi thì bảng phải đồng bộ toàn bộ mỗi chu kỳ.',
      lien: 'Cột dùng trong quan hệ — bỏ đi thì mô hình không biết nối (JOIN) với bảng nào.',
    },
  },
  troLyAiKhoThuatNgu: {
    tab: 'Ghi chú & thuật ngữ',
    luu: 'Lưu',
    them: 'Thêm dòng',
    xoa: 'Xoá dòng',
    luuHong: 'Không lưu được — {{loi}}',
    tnTieuDe: 'Từ điển thuật ngữ',
    tnMoTa: 'Giải thích bằng lời những từ ngữ riêng của tổ chức bạn. Mô hình đọc chúng trước khi viết câu lệnh.',
    tnThuatNgu: 'Thuật ngữ, ví dụ: nguồn vốn',
    tnNghia: 'Nghĩa — nói rõ lấy ở bảng nào, cột nào, và cách nào là sai',
    tnRong: 'Chưa có thuật ngữ nào. Hiện mô hình đang tự suy đoán nghĩa của các từ ngữ chuyên ngành ở mỗi lượt hỏi.',
    daLuuTn: 'Đã lưu {{n}} thuật ngữ',
    dnTieuDe: 'Định nghĩa nghiệp vụ',
    dnMoTa: 'Chặt chẽ hơn thuật ngữ: gắn trực tiếp một thuật ngữ với biểu thức SQL tính ra nó. Mô hình dùng đúng biểu thức đã khai báo thay vì tự suy ra cách tính.',
    dnThuatNgu: 'Thuật ngữ',
    dnBieuThuc: 'Biểu thức SQL, ví dụ: SUM(jdt1.credit - jdt1.debit)',
    dnPhuThuoc: 'Bảng/cột mà biểu thức dựa vào, cách nhau bằng dấu phẩy',
    dnPhuThuocGhi: 'Dạng `bang` hoặc `bang.cot`. Điền đủ thì nền tảng tự bỏ trạng thái đã xác nhận khi lược đồ thay đổi — bỏ trống thì không có cảnh báo này.',
    dnRong: 'Dùng khi một thuật ngữ luôn được tính bằng cùng một biểu thức.',
    chuaXacNhan: 'Chưa xác nhận',
    daLuuDn: 'Đã lưu {{n}} định nghĩa',
    tnRongTieuDe: 'Chưa có thuật ngữ nào',
    dnRongTieuDe: 'Chưa có định nghĩa nào',
    gcTieuDe: 'Ghi chú nghiệp vụ cho cả nguồn',
    gcMoTa: 'Định hướng bằng lời, được đưa vào ngữ cảnh của mọi câu hỏi trên nguồn này. Đây là nơi duy nhất mô tả được những điều liên quan tới nhiều bảng — bảng nào là báo cáo, bảng nào là sổ gốc, cách tính nào đã thử và sai.',
    gcViDu: 'Ví dụ:\n- Câu hỏi về bảng cân đối kế toán: dùng bảng foxai_bcdkt (mẫu B01-DN), cột ending là số cuối kỳ, so mã bằng LTRIM(RTRIM(code)). Mã 440 là tổng cộng nguồn vốn, 300 nợ phải trả, 400 vốn chủ sở hữu, 280 tổng cộng tài sản.\n- Đừng dựng lại bảng cân đối từ jdt1: cộng theo lớp tài khoản ra thiếu ~73 tỷ vì nó bù trừ số dư Nợ/Có trong cùng một tài khoản công nợ.\n- Toàn bộ nguồn này là một đơn vị. profit_code và ocr_code4 chỉ điền trên tài khoản chi phí.',
    gcDem: '{{n}}/{{tran}} ký tự — toàn bộ nội dung ở đây được gửi kèm mọi lượt hỏi',
    daLuuGhiChu: 'Đã lưu ghi chú nghiệp vụ',
    chenMau: 'Chèn mẫu kế toán VN ({{canCu}})',
    daChenMau: 'Đã chèn mẫu — đọc và sửa theo hệ thống tài khoản của doanh nghiệp bạn rồi mới bấm Lưu.',
  },
} as const;
